<template>
  <el-dialog
    title="联系人退款"
    :visible.sync="dialogVisible"
    width="600px"
    @close="handleClose"
  >
    <el-form
      ref="refundForm"
      :model="formData"
      :rules="rules"
      label-width="120px"
      v-loading="loading"
    >
      <el-form-item label="退款计划">
        <el-input v-model="planInfo.plan_title" :disabled="true"></el-input>
      </el-form-item>

      <el-form-item label="距离出发">
        <el-input :value="planInfo.near_day + '天'" :disabled="true"></el-input>
      </el-form-item>

      <el-form-item label="手续费率">
        <el-input v-model="planInfo.fee_rate" :disabled="true"></el-input>
      </el-form-item>

      <el-form-item label="选择退款乘客" prop="contcat">
        <el-checkbox-group v-model="formData.contcat">
          <el-checkbox
            v-for="contact in contacts"
            :key="contact.id"
            :label="contact.id"
            :disabled="contact.status !== 1"
          >
            {{ contact.name }}
            <span v-if="contact.status !== 1" style="color: #909399;">(已退款)</span>
          </el-checkbox>
        </el-checkbox-group>
      </el-form-item>

      <el-form-item label="退款类型" prop="type">
        <el-radio-group v-model="formData.type">
          <el-radio :label="1">正常退款</el-radio>
          <el-radio :label="2">特殊退款</el-radio>
        </el-radio-group>
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" @click="handleSubmit" :loading="submitting">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import axios from 'axios'

export default {
  name: 'ContactRefundDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    orderId: {
      type: [String, Number],
      default: null
    }
  },
  data() {
    return {
      dialogVisible: false,
      loading: false,
      submitting: false,
      contacts: [],
      planInfo: {
        plan_title: '',
        near_day: 0,
        fee_rate: '',
        currency: '',
        rate: 0,
        inc: 0
      },
      formData: {
        contcat: [],
        type: 1
      },
      rules: {
        contcat: [
          { required: true, message: '请选择退款乘客', trigger: 'change' },
          { type: 'array', min: 1, message: '至少选择一个乘客', trigger: 'change' }
        ],
        type: [
          { required: true, message: '请选择退款类型', trigger: 'change' }
        ]
      }
    }
  },
  watch: {
    visible(newVal) {
      this.dialogVisible = newVal
      if (newVal && this.orderId) {
        this.loadFormData()
      }
    },
    dialogVisible(newVal) {
      if (!newVal) {
        this.$emit('update:visible', false)
      }
    }
  },
  methods: {
    async loadFormData() {
      if (!this.orderId) return
      
      this.loading = true
      try {
        const response = await axios.get(`${this.base_url}/orders/${this.orderId}/contact-refund/form`)
        if (response.status === 200 && response.data.code) {
          const data = response.data.data
          this.planInfo = {
            plan_title: data.plan_title || '',
            near_day: data.near_day || 0,
            fee_rate: data.fee_rate || '',
            currency: data.currency || '',
            rate: data.rate || 0,
            inc: data.inc || 0
          }
          this.contacts = data.contacts || []
        } else {
          this.$message.error(response.data.message || '获取表单数据失败')
        }
      } catch (error) {
        console.error('获取表单数据失败:', error)
        this.$message.error('获取表单数据失败')
      } finally {
        this.loading = false
      }
    },

    async handleSubmit() {
      this.$refs.refundForm.validate(async (valid) => {
        if (valid) {
          this.submitting = true
          try {
            const response = await axios.post(`${this.base_url}/orders/${this.orderId}/contact-refund/submit`, this.formData)
            if (response.status === 200 && response.data.code) {
              this.$message.success('联系人退款处理成功')
              this.dialogVisible = false
              this.$emit('success')
            } else {
              this.$message.error(response.data.message || '退款处理失败')
            }
          } catch (error) {
            console.error('退款处理失败:', error)
            this.$message.error('退款处理失败')
          } finally {
            this.submitting = false
          }
        } else {
          this.$message.error('请检查表单填写是否正确')
        }
      })
    },

    handleClose() {
      this.dialogVisible = false
      this.resetForm()
    },

    resetForm() {
      this.$refs.refundForm && this.$refs.refundForm.resetFields()
      this.formData = {
        contcat: [],
        type: 1
      }
      this.contacts = []
      this.planInfo = {
        plan_title: '',
        near_day: 0,
        fee_rate: '',
        currency: '',
        rate: 0,
        inc: 0
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog-footer {
  text-align: right;
}

.el-form {
  .el-select {
    width: 100%;
  }
}

.el-checkbox-group {
  .el-checkbox {
    display: block;
    margin-bottom: 10px;
  }
}
</style>